import { render, staticRenderFns } from "./ViewPayPlanChangeRequest.vue?vue&type=template&id=06588d4e"
import script from "./ViewPayPlanChangeRequest.vue?vue&type=script&lang=ts"
export * from "./ViewPayPlanChangeRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports